module.exports = __webpack_public_path__ + "img/播放.08ada802.png";